import IconTick from "app/components/Icon/components/IconTick/IconTick";
import { memo } from "react";
import { FormattedMessage } from "react-intl";

const RegistrationProgressSteps = ({
  selectedScreen,
}: {
  selectedScreen: string;
}) => {
  return (
    <div className={`form-progress-checks ${selectedScreen}`}>
      <div>
        <IconTick />
        <FormattedMessage tagName="span" id="settings-accountdetails" />
      </div>
      <div>
        <IconTick />
        <FormattedMessage tagName="span" id="home-register-personal-details" />
      </div>
      <div>
        <IconTick />
        <FormattedMessage tagName="span" id="register-account-settings" />
      </div>
    </div>
  );
};

export default memo(RegistrationProgressSteps);
